import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Container } from '@/components/layout/Container'
import { journalArticles } from '@/data/journal'

export function Journal() {
  return (
    <div className="pt-28 pb-24">
      <Container>
        <p className="mb-4 text-xs uppercase tracking-[0.2em] text-wd-orange">Journal notes</p>
        <h1 className="mb-4 font-display text-4xl normal-case text-carbon md:text-5xl">
          journal
        </h1>
        <p className="mb-16 max-w-2xl text-carbon/60">
          Notes on perfumery, scent science, and how to build a fragrance wardrobe.
        </p>

        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          {journalArticles.map((article, index) => (
            <motion.article
              key={article.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Link to={`/journal/${article.slug}`} className="group block">
                <div className="mb-4 aspect-[3/2] overflow-hidden bg-wd-mist">
                  <img
                    src={article.image}
                    alt={article.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <p className="mb-2 text-xs text-carbon/50">{article.publishedAt} · {article.readTime} min read</p>
                <h2 className="font-display text-2xl normal-case text-carbon transition-colors group-hover:text-wd-orange">
                  {article.title.toLowerCase()}
                </h2>
                <p className="mt-2 text-sm text-carbon/60">{article.excerpt}</p>
              </Link>
            </motion.article>
          ))}
        </div>
      </Container>
    </div>
  )
}
